<template>
  <v-form ref="form">
    <v-layout row wrap class="procedure-container">
      <!--minutes-->
      <v-flex xs12 md2>
        <v-tooltip :disabled="!showTooltip" top>
          <v-text-field
            v-model="record.minutes"
            :error-messages="minutesErrors"
            @input="v.$each[index].minutes.$touch()"
            @blur="v.$each[index].minutes.$touch()"
            @change="calculateMinutes"
            slot="activator"
            type="number"
            label="Minutes"
            placeholder="# Mins"
            required>
          </v-text-field>
          <span>Enter # of minutes for procedure</span>
        </v-tooltip>
      </v-flex>
      <!--procedure-->
      <v-flex xs12 md9>
        <v-tooltip :disabled="!showTooltip" top>
          <v-combobox
            slot="activator"
            :items="medicaidArray"
            label="Procedure Description"
            placeholder="Enter Procedure Description"
            item-text="procedureName"
            :error-messages="procedureErrors"
            @blur="v.$each[index].procedure.$touch()"
            @change="procedureChanged"
            :return-object="true"
            v-model="record.procedure">
            <template slot="selection" slot-scope="{item, selected}">
              <!--if theres a category name and procedure name, display it-->
              <div v-if="item.categoryId && item.procedureName">
                {{ item.procedureName }}
              </div>
              <!--else, user entered text, category is other-->
              <div v-else>
                <strong>Other</strong>: {{ record.procedureName }}
              </div>
            </template>
          </v-combobox>
          <span>Select one or more procedure description(s)</span>
        </v-tooltip>
      </v-flex>
      <!--delete button-->
      <v-flex xs12 md1>
        <v-layout row wrap justify-end>
          <v-tooltip :disabled="!showTooltip" top>
            <v-icon
              slot="activator"
              id="deleteIcon"
              @click="emitRemoveRecordClicked(index)"
              style="padding-top: 20px;">
              mdi-delete
            </v-icon>
            <span>Delete procedure</span>
          </v-tooltip>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import Swal from 'sweetalert2';

export default {
  name: 'MedicaidRepeatable',
  props: ['medicaidArray', 'student', 'index', 'record', 'showTooltip', 'v'],
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    },
    isTablet() {
      return this.$mq === 'tablet';
    },
    minutesErrors() {
      const errors = [];
      const minutes = this.v.$each[this.index].minutes;
      if (!minutes.$dirty) return errors;
      if (!minutes.required) errors.push('Minutes are required.');
      if (!minutes.areMinutesGreaterThanZero) errors.push('Minutes must be greater than 0.');
      if (!minutes.isValidMinutes) errors.push('Invalid minutes.');
      return errors;
    },
    procedureErrors() {
      const errors = [];
      const procedure = this.v.$each[this.index].procedure;
      if (!procedure.$dirty) return errors;
      if (!procedure.required) errors.push('Procedure Description is required.');
      return errors;
    }
  },
  methods: {
    emitRemoveRecordClicked() {
      Swal.fire({
        text: 'Are you sure you want to delete this record?',
        confirmButtonText: 'Delete',
        showCancelButton: true,
        customClass: {
          popup: 'popup-class',
          content: 'content-class',
          confirmButton: 'confirm-button-class delete'
        }
      }).then((response) => {
        if (response && response.value) this.$emit('delete:record', { index: this.index });
      });
    },
    remove(item) {
      this.record.objectives = this.record.objectives.filter((obj) => {
        return obj.objectiveDescription !== item;
      });
    },
    formatRecord(procedure) {
      if (typeof procedure === 'string') {
        this.record.procedure = {
          categoryId: null,
          categoryName: 'Other',
          categorySortOrder: null,
          disabled: false,
          procedureFullName: `Other: ${procedure}`,
          procedureId: null,
          procedureName: procedure,
          procedureSortOrder: null,
          reimbursable: false
        }
      }
      if (this.record.procedure) {
        this.record.procedureId = this.record.procedure.procedureId;
        this.record.procedureName = this.record.procedure.procedureName;
      } else {
        this.record.procedureId = null;
        this.record.procedureName = null;
      }
    },
    procedureChanged(val) {
      this.formatRecord(val);
      this.calculateMinutes();
    },
    calculateMinutes() {
      this.$emit('calculate:minutes');
    }
  }
};
</script>

<style lang="scss" scoped>
  .procedure-container {
    margin: 20px 0 !important;
    padding: 20px 15px 0 15px;
    background-color: #fff;
    box-shadow: 0 0 8px rgba(0,0,0,0.2);
    border-radius: 10px;
  }

  #deleteIcon:hover {
    color: var(--v-error-base);
  }

  /deep/ .objective-select {
    .v-select__selections {
      max-width: 96%;
      .objective-chip {
        max-width: 98%;
        .v-chip__content {
          width: 100%;
          span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/service-log/form/medicaid-repeatable.vue